import React, { useState, useEffect } from "react";
import {
  Input,
  TextArea,
  Select,
  TextAreaAdvanced,
} from "../../../../../Layout/Forms/Form";
import { Puff } from "react-loading-icons";
import VipTablesTabs from "../VipTablesTabs";
import VipTablesRequests from "../VipTablesRequests";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../../../../../components/NavBar";

const FormDetailsPayment = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    isEditable: false,
    form: {
      id: 0,
      name: "",
      iban: "",
      vat_number: "",
      address: "",
      city: "",
      postal_code: "",
    },

    errors: [],
  });

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  useEffect(() => {
    getInfoForm();
  }, []);

  const getInfoForm = async () => {
    setIsLoading(true);
    let info = await VipTablesRequests.infoPaymentDetails({
      id_venues: params.id,
    });
    if (info && info.status) {
      setState({
        ...state,
        form: info.data,
      });
    } else {
      toast.error("Não foi possivel obter os dados.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setIsLoading(false);
  };

  const handlerSaveFormDetailsPayment = async () => {
    let info = await VipTablesRequests.savePaymentDetails({
      ...state.form,
      id_venues: params.id,
    });
    if (info && info.status) {
      toast.success("Os seu dados foram guardados com sucesso", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setState({ ...state, isEditable: false });
    } else {
      setState({
        ...state,
        errors: info.errors,
      });
    }
  };

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A carregar detalhes...</div>
    </div>
  );

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb premium-breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/my/nightspots">Nightspots</Link>
            </li>
            <li className="breadcrumb-item active">Detalhes Faturação</li>
          </ol>
        </nav>

        <VipTablesTabs tab="invoice" />

        {isLoading ? (
          <InsideLoading />
        ) : (
          <div className="row justify-content-center">
            <div className="col-12 col-xl-8">
              <div className="instruction-box p-4 p-md-5 rounded-4 border-0">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h2 className="campaigns-section-title fs-2 mb-1">Detalhes de Faturação</h2>
                    <p className="campaigns-section-subtitle mb-0">Mantém os teus dados atualizados para uma faturação correta.</p>
                  </div>
                  {!state.isEditable && (
                    <button
                      type="button"
                      className="btn-action btn-campaign-primary px-4 rounded-pill w-auto py-2"
                      onClick={() => setState({ ...state, isEditable: true })}
                    >
                      <i className="fa-solid fa-pencil me-2"></i>Editar
                    </button>
                  )}
                </div>

                <div className="row g-4">
                  <div className="col-12">
                    <Input
                      label="Nome ou Razão Social"
                      name="name"
                      placeholder="Ex: Nightspot LDA"
                      value={state.form.name}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <Input
                      label="NIF / Contribuinte"
                      name="vat_number"
                      placeholder="Ex: 500123456"
                      value={state.form.vat_number}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <Input
                      label="IBAN para Recebimento"
                      name="iban"
                      placeholder="PT50..."
                      value={state.form.iban}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>

                  <div className="col-12">
                    <Input
                      label="Morada Completa"
                      name="address"
                      value={state.form.address}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <Input
                      label="Localidade"
                      name="city"
                      value={state.form.city}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <Input
                      label="Código Postal"
                      name="postal_code"
                      value={state.form.postal_code}
                      onChange={(e) => handleChangeInputs(e)}
                      className="form-control glass-input"
                      type="text"
                      placeholder="0000-000"
                      errors={state.errors}
                      readOnly={!state.isEditable}
                    />
                  </div>
                </div>

                {state.isEditable && (
                  <div className="row g-3 mt-4">
                    <div className="col-12 col-md-6">
                      <button
                        type="button"
                        className="btn-action glass-glow btn-campaign-primary w-100 py-3 rounded-pill"
                        onClick={() => handlerSaveFormDetailsPayment()}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>Guardar Alterações
                      </button>
                    </div>
                    <div className="col-12 col-md-6">
                      <button
                        type="button"
                        className="btn-action btn-campaign-secondary w-100 py-3 rounded-pill"
                        onClick={() => setState({ ...state, isEditable: false })}
                      >
                        <i className="fa-solid fa-times me-2"></i>Cancelar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </NavBar>
  );
};

export default FormDetailsPayment;
